(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-ak"] && !Shopify.designMode) return;
  try {
    (() => {
    const CM = 2.54;
    const fmt = (inches, unit) =>
      unit === 'cm' ? (inches * CM).toFixed(inches >= 10 ? 0 : 1) : String(Math.round(inches * 100) / 100);

    const suggest = (dialog) => {
      const out = dialog.querySelector('[data-size-result]');
      const unit = dialog.dataset.unit;
      const input = dialog.querySelector('[data-chest]');
      const raw = parseFloat(input.value);
      if (!raw) {
        dialog.querySelectorAll('tr[data-suggested]').forEach((item) => item.removeAttribute('data-suggested'));
        out.textContent = '';
        return;
      }
      // after a unit switch the box shows a rounded value; dataset.inches keeps the exact one until the shopper types
      const chest = input.dataset.inches ? Number(input.dataset.inches) : unit === 'cm' ? raw / CM : raw;
      if (chest < 20 || chest > 80) {
        dialog.querySelectorAll('tr[data-suggested]').forEach((item) => item.removeAttribute('data-suggested'));
        out.textContent = 'Enter your chest measurement all the way around, for example 40 in or 102 cm.';
        return;
      }
      const fit = Number(dialog.querySelector('[data-fit]:checked')?.value ?? 1);
      const ease = dialog.dataset.ease.split(',').map(Number)[fit];
      const rows = [...dialog.querySelectorAll('tr[data-width]')];
      const match = rows.find((row) => 2 * row.dataset.width >= chest + ease);
      const row = match || rows[rows.length - 1];
      rows.forEach((item) => item.toggleAttribute('data-suggested', item === match));
      const around = `${fmt(2 * row.dataset.width, unit)} ${unit}`;
      out.textContent = match
        ? `We suggest size ${row.dataset.size}. Its chest measures ${around} all the way around (highlighted in the Size chart tab).`
        : `You measure above our largest size. Size ${row.dataset.size} (chest ${around} all the way around) may be tight.`;
    };

    const setUnit = (dialog, unit) => {
      const input = dialog.querySelector('[data-chest]');
      const from = dialog.dataset.unit;
      if (input.value && from !== unit) {
        const inches = input.dataset.inches ? Number(input.dataset.inches) : parseFloat(input.value) / (from === 'cm' ? CM : 1);
        input.value = String(Math.round((unit === 'cm' ? inches * CM : inches) * 10) / 10);
        input.dataset.inches = String(inches);
      }
      dialog.dataset.unit = unit;
      dialog.querySelectorAll('[data-in]').forEach((el) => (el.textContent = fmt(Number(el.dataset.in), unit)));
      dialog.querySelectorAll('[data-unit-label]').forEach((el) => (el.textContent = unit));
      dialog
        .querySelectorAll('[data-unit-btn]')
        .forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.unitBtn === unit)));
      suggest(dialog);
    };

    const selectTab = (tab, focus) => {
      tab
        .closest('[role="tablist"]')
        .querySelectorAll('[role="tab"]')
        .forEach((item) => {
          const on = item === tab;
          item.setAttribute('aria-selected', String(on));
          item.tabIndex = on ? 0 : -1;
          document.getElementById(item.getAttribute('aria-controls')).hidden = !on;
        });
      if (focus) tab.focus();
    };

    // Delegated on document: Dawn swaps <variant-selects> (and the button inside it) on every option change.
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-size-chart-open]');
      if (opener) {
        const dialog = document.getElementById(opener.getAttribute('aria-controls'));
        if (!dialog) return;
        setUnit(dialog, dialog.dataset.unit);
        dialog.showModal();
        return;
      }
      const dialog = event.target.closest('dialog.size-chart-ak');
      if (!dialog) return;
      const box = dialog.getBoundingClientRect();
      const onBackdrop =
        event.target === dialog &&
        (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
      if (onBackdrop || event.target.closest('[data-size-chart-close]')) {
        dialog.close();
        return;
      }
      const tab = event.target.closest('[role="tab"]');
      if (tab) {
        selectTab(tab, false);
        return;
      }
      const unitButton = event.target.closest('[data-unit-btn]');
      if (unitButton) setUnit(dialog, unitButton.dataset.unitBtn);
    });

    document.addEventListener('keydown', (event) => {
      const tab = event.target.closest?.('.size-chart-ak [role="tab"]');
      const step = { ArrowLeft: -1, ArrowRight: 1 }[event.key];
      if (!tab || !step) return;
      event.preventDefault();
      const tabs = [...tab.parentElement.querySelectorAll('[role="tab"]')];
      selectTab(tabs[(tabs.indexOf(tab) + step + tabs.length) % tabs.length], true);
    });

    document.addEventListener('input', (event) => {
      const dialog = event.target.closest?.('dialog.size-chart-ak');
      if (!dialog) return;
      if (event.target.matches('[data-chest]')) delete event.target.dataset.inches;
      suggest(dialog);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
